import createApp from './main';
import '../../../style/pages/error/not-found.scss';

const { app } = createApp();
app.mount('#app');
